import React, { useEffect, useState } from "react"; 
import { FullPageChat } from "flowise-embed-react"


interface GarbageItemType {
  name: string;
  number: string;
  type: string;
}

const ButtonsGamePage: React.FC = () => {
  
 
  return (
    
            <FullPageChat
          chatflowid="87d1a2f7-a35b-4ccf-9b14-11f5dc8a91dc"
                apiHost="https://flow-dev.loacker.cc"
             
        />
          );
};

export default ButtonsGamePage;
